import Flux from 'lib/flux';

const CurrencyConstants = Flux.createConstants({
  serviceMessages: ['CURRENCY_UPDATED'],
});

export default CurrencyConstants;
